(() => {
  const initialized = new WeakSet();
  const initialize = (root) => {
    if (initialized.has(root)) return;
    initialized.add(root);
    const rail = root.querySelector('[data-brand-rail]');
    const controls = root.querySelector('[data-brand-controls]');
    if (!rail || !controls) return;
    const previous = controls.querySelector('[data-brand-prev]');
    const next = controls.querySelector('[data-brand-next]');
    const update = () => {
      const end = rail.scrollWidth - rail.clientWidth;
      controls.hidden = end < 2;
      previous.disabled = rail.scrollLeft <= 2;
      next.disabled = rail.scrollLeft >= end - 2;
    };
    const move = (direction) => {
      const card = rail.querySelector('.nw-brand-world__topic');
      const gap = parseFloat(getComputedStyle(rail).columnGap) || 0;
      const distance = (card?.getBoundingClientRect().width || rail.clientWidth) + gap;
      rail.scrollBy({ left: direction * distance, behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
    };
    previous.addEventListener('click', () => move(-1));
    next.addEventListener('click', () => move(1));
    rail.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    update();
  };
  const scan = () => document.querySelectorAll('[data-brand-world]').forEach(initialize);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan, { once: true });
  else scan();
  document.addEventListener('shopify:section:load', scan);
})();
